import { FileType } from '@office-start/document-types';
/**
 * Wrapper utility function to be used with @uifabric's getFileTypeIconProps method.
 * Maps 'extensionless' files (like Forms or Streams) to extensions to be passed into getFileTypeIconProps
 * @param: fileType the fileType of the item
 * @todo: missing forms, microsoft project icons
 */
export function getFileExtensionFromFileType(fileType) {
    switch (fileType) {
        case FileType.Excel:
            return 'xls';
        case FileType.List:
            return 'listitem';
        case FileType.Fluid:
            return 'fluid';
        case FileType.MeetingNotes:
            return 'note';
        case FileType.OneNote:
        case FileType.OneNotePage:
            return 'onetoc';
        case FileType.PowerBI:
            return 'pbids';
        case FileType.PowerPoint:
            return 'pptx';
        case FileType.Visio:
            return 'vsdx';
        case FileType.Whiteboard:
            return 'whiteboard';
        case FileType.Word:
            return 'docx';
        case FileType.Designer:
            return 'designer';
        case FileType.Clipchamp:
            return 'clipchamp';
        case FileType.Draft:
            return 'draft';
        default:
            return null;
    }
}
//# sourceMappingURL=getFileExtensionFromFileType.js.map